export const FormTemplates = {
  TextInputForm: "TextInputForm",
  CheckBoxesForm: "CheckboxesForm",
  DateForm: "DateForm",
  RadioForm: "RadioForm",
  LabelForm: "LabelForm",
  ConditionalForm: "ConditionalForm",
  DynamicallyExtensibleForm: "DynamicallyExtensibleForm",
  PersonalDataFormTemplate: "PersonalDataFormTemplate",
  AddictionsFormTemplate: "AddictionsFormTemplate",
  PersonalDataWithAddictionsTemplate: "PersonalDataWithAddictionsTemplate",
};

export const InputFormTypes = {
  Text: "Text",
  // Number: "Number",
  Date: "Date",
  CheckBox: "Checkbox",
  Radio: "Radio",
  Label: "Label",
};

export const ActionCategory = {
  AvailableActions: "Available Actions",
  Templates: "Templates",
};

export const InputCategory = {
  Text: "Text",
  // Number: "Number",
  Date: "Date",
  CheckBox: "Checkbox",
  Radio: "Radio",
  Label: "Label",
};

export const ConditionalOperators = {
  IsEqual: "Is Equal",
  IsLess: "Is Less",
  IsMore: "Is More",
};

export class InputFormAction {
  labelName;
}
